import axios from "axios"

const baseUrl = process.env.VUE_APP_BASE_URL

const phrasestorages = 
{
    namespaced: true,
    state: {
        phrasestorages: [],
        phrasestorage: {}
    },
    mutations: {
        SET_PHRASESTORAGES(state, data)
        {
            state.phrasestorages = data
        },
        SET_PHRASESTORAGE(state, data)
        {
            state.phrasestorage = data
        }
    },
    actions: {
        getAll ({ commit }) {
          return axios 
          .get(baseUrl+'PhraseStorage', { withCredentials: true })
          .then(res => {
              console.log(res.data);
              commit('SET_PHRASESTORAGES', res.data)
             
          })
          .catch(error => console.log(error))
        },

        deletePhraseStorage ({ commit }, id) {
            return axios
            .get(baseUrl+'DeleteVendor?vendorId=' + id, { withCredentials: true })
            .catch(error => console.log(error))
          },
          updatePhraseStorage({ commit }, {id, data}){
            return axios
            .post(baseUrl+'PhraseStorage/updatePhraseStorage/', id, data, { withCredentials: true })
            .then(res => {

                console.log(res)
            })
          },
          
          //This get vendor is used to get a fresh copy from the db to load full details. the getter vendor is used to get current grid vendor
          getPhraseStorage ({ commit },id) {
            return axios
            .get(baseUrl+'GetVendor?vendorId=' + id, { withCredentials: true })
            .then(res => {
                commit('SET_VENDOR', res.data)
            })
            .catch(error => console.log(error))
        },
        addNewPhraseStorage ({ commit }, data) {
            return axios
            .post(baseUrl+'PhraseStorage/addPhraseStorage', data, { withCredentials: true })
            .then(res => {
                console.log("new phrase storage added",res.data)
            })
            .catch(error => console.log(error))
        }
      },
      getters: {}
}

export default phrasestorages